/** Faithful HasList / HasIdByVariable / HasById over PHP catalog CONSTANTS.
 * Static class caches belong to PortEnv, never module state.
 * Regenerate catalog-constants.json with tools/test/k2-catalog-constants.php.
 */
import definitions from './catalog-constants.json';
import { phpCopy, fromJson } from '../../php-compat';
import { at, array, isArray, list, values } from './php-shapes';
import type { PortEnv } from '../../port-contract';
type CatalogName = keyof typeof definitions;
export function catalogAll(name: CatalogName): unknown {
    return fromJson(definitions[name], true);
}
export function catalogId(name: CatalogName, variable: string, env: Pick<PortEnv<object>, 'globals'>): unknown {
    const key = `${name}::$idCache`;
    const cache = isArray(env.globals[key]) ? array(env.globals[key]) : list([]);
    const existing = cache.get(variable); if (existing !== undefined && existing !== null) return existing;
    for (const item of values(catalogAll(name))) if ((at(item, 'variable_name') ?? null) === variable) {
        const id = at(item, 'item_id'); cache.set(variable, id); env.globals[key] = cache; return id;
    }
    cache.set(variable, null); env.globals[key] = cache; return null;
}
export function catalogById(name: CatalogName, id: string, env: PortEnv<{check_uuid(id: unknown): boolean}>): unknown {
    if (id === '' || !env.deps.check_uuid(id)) return null;
    for (const item of values(catalogAll(name))) if ((at(item, 'item_id') ?? null) === id) return phpCopy(item);
    return null;
}
